import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const branchOfficeDetails = createAsyncThunk('branchOfficeDetails', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `branch_office/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const branchOfficeDetailsSlice = createSlice({
    name: 'branchOfficeDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(branchOfficeDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }
        });
        builder.addCase(branchOfficeDetails.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default branchOfficeDetailsSlice.reducer;
